import ClubEmployeeAccountSettingsRepository from '../repository/ClubEmployeeAccountSettingsRepository';

export default class AvatarUrlGenerator {

    static clubEmployeeAvatarUrl(clubEmployeeNotificationAndAvatar, size, forceIgnoreCache) {
        if (!clubEmployeeNotificationAndAvatar.hasAvatar) {
            if (!clubEmployeeNotificationAndAvatar.gender || clubEmployeeNotificationAndAvatar.gender === 'gender.u') {
                return kgr.assetsUrls['clubityAvatarUnknown'];
            } else if (clubEmployeeNotificationAndAvatar.gender === 'gender.f') {
                return kgr.assetsUrls['avatarFemale'];
            }

            return kgr.assetsUrls['avatarMale'];
        }

        return ClubEmployeeAccountSettingsRepository.avatarUrl(clubEmployeeNotificationAndAvatar.id, size, forceIgnoreCache);
    }
}
